var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableGamesNew(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2637_57139)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.561 9.4602C19.5733 9.41526 19.5815 9.36623 19.5896 9.32129L19.561 9.4602Z",
    fill: "url(#paint0_linear_2637_57139)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.86262 11.4587C7.87874 11.3814 7.89244 11.3038 7.90374 11.2262C7.89156 11.3158 7.87619 11.4052 7.8576 11.4944L7.77587 11.8908C8.02641 10.6898 8.98523 9.76745 10.189 9.55697L18.4653 8.39248C18.5222 8.38467 18.5765 8.37161 18.6279 8.35393C18.6609 8.34256 18.6946 8.33278 18.7292 8.32791V8.32791C19.2318 8.25845 19.6527 8.66707 19.6241 9.15332C19.6404 9.05525 19.6445 8.9531 19.6445 8.84686C19.6445 8.33388 19.4863 7.84054 19.2373 7.42736C19.1669 7.31052 19.1054 7.18703 19.0251 7.07674V7.07674L15.0003 1.54815C14.183 0.424458 12.8101 -0.155779 11.433 0.0362713L4.0575 1.07416C4.00723 1.08111 3.95837 1.09088 3.911 1.10325C3.77392 1.13905 3.64037 1.18881 3.50598 1.23368C2.61887 1.52981 1.91075 2.30176 1.68167 3.21692C1.63045 3.42153 1.56034 3.62348 1.5168 3.82985V3.82985L0.17245 10.2533C-0.0359442 11.2544 0.188796 12.3005 0.789463 13.1259L4.45884 18.1641V18.1641C4.60927 18.3708 4.79248 18.5561 4.95154 18.7562C5.51552 19.466 6.42583 19.9041 7.42378 19.9041V19.9041C7.49986 19.9041 7.52139 19.7686 7.4596 19.7242C6.86101 19.2942 6.56714 18.1822 6.72424 17.4212L6.7937 17.0902V17.0902C6.76965 17.2048 6.66545 17.1686 6.68948 17.054L7.86262 11.4587ZM3.69637 6.9277C3.639 6.62939 3.50132 6.36932 3.33304 6.18575C3.16093 6.00217 2.95441 5.90273 2.75553 5.91803C2.35778 5.9601 2.12449 6.47259 2.24305 7.06921C2.30041 7.36752 2.4381 7.62759 2.60638 7.81117C2.77848 7.99475 2.985 8.09801 3.18388 8.07889C3.58545 8.03682 3.81493 7.52433 3.69637 6.9277ZM4.09399 10.0453C4.26227 10.2289 4.39995 10.4889 4.45732 10.7872C4.57588 11.3839 4.34258 11.8964 3.94483 11.9384C3.74213 11.9575 3.53943 11.8543 3.36733 11.6745C3.19905 11.4909 3.06136 11.2309 3.004 10.9326C2.88544 10.3359 3.11491 9.82346 3.51648 9.78139C3.71918 9.75844 3.92188 9.8617 4.09399 10.0453ZM5.20684 14.5811C5.14947 14.2828 5.01179 14.0227 4.84351 13.8391C4.67141 13.6555 4.46488 13.5523 4.26601 13.5752C3.86443 13.6173 3.63496 14.1298 3.75352 14.7264C3.81089 15.0247 3.94857 15.2848 4.11685 15.4684C4.28896 15.6481 4.49165 15.7514 4.69435 15.7322C5.09211 15.6902 5.3254 15.1777 5.20684 14.5811Z",
    fill: "url(#paint1_linear_2637_57139)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06955 2.08476C7.59258 2.01529 8.24636 2.37488 8.52831 2.88973C8.81026 3.40459 8.6182 3.87859 8.09517 3.94805C7.57215 4.01752 6.91836 3.65793 6.63641 3.14308C6.35447 2.62822 6.54652 2.15422 7.06955 2.08476Z",
    fill: "#80D474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8377 1.45048C12.3607 1.38102 13.0145 1.7406 13.2965 2.25546C13.5784 2.77031 13.3864 3.24431 12.8633 3.31377C12.3403 3.38324 11.6865 3.02366 11.4046 2.5088C11.1186 1.99394 11.3147 1.51995 11.8377 1.45048Z",
    fill: "#80D474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19001 5.92509C9.71304 5.85563 10.3668 6.21521 10.6488 6.73006C10.9307 7.24492 10.7387 7.71892 10.2156 7.78838C9.69261 7.85785 9.03882 7.49826 8.75688 6.98341C8.47085 6.46855 8.66698 5.99455 9.19001 5.92509Z",
    fill: "#80D474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9548 5.29277C14.4778 5.2233 15.1316 5.58288 15.4136 6.09774C15.6955 6.6126 15.5035 7.08659 14.9804 7.15606C14.4574 7.22552 13.8036 6.86594 13.5217 6.35108C13.2397 5.83623 13.4318 5.36223 13.9548 5.29277Z",
    fill: "#80D474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4243 3.69804C10.9473 3.62857 11.6011 3.98816 11.883 4.50301C12.165 5.01787 11.9729 5.49187 11.4499 5.56133C10.931 5.6308 10.2772 5.27121 9.99115 4.75636C9.70921 4.2415 9.90125 3.7675 10.4243 3.69804Z",
    fill: "#80D474"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.602 9.26008L18.086 16.4967C17.8122 17.8002 16.7498 18.7931 15.43 18.9811L8.2792 19.9863C7.16367 20.1415 6.23203 19.1445 6.46494 18.0453L7.76026 11.8589C8.01768 10.6249 9.02288 9.68504 10.2732 9.50934L18.7194 8.32026C19.2628 8.24263 19.7164 8.7248 19.602 9.26008ZM15.0294 14.433C15.4258 14.3757 15.7894 14.4575 16.0387 14.6904C16.529 15.1521 16.3492 16.0388 15.6342 16.6722C15.2787 16.9868 14.8537 17.1789 14.4573 17.2361C14.061 17.2933 13.6973 17.2115 13.4521 16.9786C12.9618 16.5169 13.1416 15.6302 13.8567 14.9968C14.2122 14.6822 14.633 14.4902 15.0294 14.433ZM12.8557 11.6997C12.6105 11.4668 12.2468 11.3851 11.8505 11.4423C11.4582 11.4954 11.0332 11.6875 10.6737 12.0062C9.95858 12.6395 9.77878 13.5262 10.2691 13.988C10.5184 14.2209 10.882 14.3026 11.2784 14.2454C11.6707 14.1882 12.0956 13.9961 12.4511 13.6815C13.1662 13.0482 13.346 12.1615 12.8557 11.6997Z",
    fill: "#80D474"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2637_57139",
    x1: 19.5706,
    y1: 9.56372,
    x2: 19.5129,
    y2: 9.05257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0926412,
    stopColor: "#CBC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730406,
    stopColor: "#ABAAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2637_57139",
    x1: -11.2666,
    y1: -10.9293,
    x2: 31.2342,
    y2: 30.2251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9ECC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997776,
    stopColor: "#A6E09E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2637_57139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableGamesNew);
export default __webpack_public_path__ + "static/media/table-games-new.3ec77b66c543154cd15cf8aa0a35fe32.svg";
export { ForwardRef as ReactComponent };